import script from "./hongshu.vue?vue&type=script&setup=true&lang=js"
export * from "./hongshu.vue?vue&type=script&setup=true&lang=js"

import "./hongshu.vue?vue&type=style&index=0&id=4c6ef16d&lang=less&scoped=true"
script.__scopeId = "data-v-4c6ef16d"

export default script